"use strict";
const createSearchStringQuery = search => {
    const searchOrs = [
        { '$copackAgreement.name$': { iLike: `%${search.replace(' ', '%')}%` } },
        {
            '$orderBrokerageAgreement.name$': {
                iLike: `%${search.replace(' ', '%')}%`,
            },
        },
    ];
    const settlementNumber = /^\d+$/.test(search)
        ? Number.parseInt(search, 10)
        : undefined;
    if (settlementNumber) {
        searchOrs.push({ settlementNumber: { eq: settlementNumber } });
    }
    return { or: searchOrs };
};
module.exports = createSearchStringQuery;
